import { render } from "./PhoneUi.vue?vue&type=template&id=53ee06dc"
import script from "./PhoneUi.vue?vue&type=script&lang=js"
export * from "./PhoneUi.vue?vue&type=script&lang=js"

import "./PhoneUi.vue?vue&type=style&index=0&id=53ee06dc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__